import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  getTcRequest,
  getTcRequestSuccess,
  getTcRequestError,
} from "../../../slices/teams/members/GetTcSlice";

export const GetTc = () => async (dispatch) => {
  try {
    dispatch(getTcRequest());

    const response = await axiosInstance.get(endpoints.getTc, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(getTcRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status || error?.status,
    };
    dispatch(getTcRequestError(_error));
    throw _error;
  }
};
